import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "@/components/Layout";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import LegalHub from "@/pages/LegalHub";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              {/* Public marketing pages */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<LegalPage pageKey="aboutPage" />} />
              <Route path="/services" element={<LegalPage pageKey="servicesPage" />} />
              <Route path="/contact" element={<LegalPage pageKey="contactPage" />} />

              {/* Legal & customer-protection pages (crawlable, not in main nav) */}
              <Route path="/legal" element={<LegalHub />} />
              <Route path="/privacy-policy" element={<LegalPage pageKey="privacyPage" />} />
              <Route path="/terms-and-conditions" element={<LegalPage pageKey="termsPage" />} />
              <Route path="/refund-policy" element={<LegalPage pageKey="refundPolicyPage" />} />
              <Route path="/data-deletion" element={<LegalPage pageKey="dataDeletionPage" />} />
              <Route path="/company-information" element={<LegalPage pageKey="companyInformationPage" />} />

              {/* Redirects from older URL slugs to current neutral URLs */}
              <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
              <Route path="/terms" element={<Navigate to="/terms-and-conditions" replace />} />
              <Route path="/meta-integration" element={<Navigate to="/legal" replace />} />
              <Route path="/meta-compliance" element={<Navigate to="/legal" replace />} />
              <Route path="/meta-compliance-page" element={<Navigate to="/legal" replace />} />
              <Route path="/meta-privacy-compliance" element={<Navigate to="/privacy-policy" replace />} />
              <Route path="/app-review" element={<Navigate to="/legal" replace />} />
              <Route path="/app-review/*" element={<Navigate to="/legal" replace />} />

              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
